/* eslint-disable import/no-dynamic-require */
// eslint-disable-next-line no-redeclare
/* global require, process */
import coreCommonConfig from "./common.json";
import commonConfig from "../../config/common.json";
import environmentConfig from "../../config/environment";

const coreEnvironmentConfig = require(`./${process.env.NODE_ENV}.json`);
const userGuideConfig = require("../../config/userGuide.json");

export default {
  // colors: colors.global,
  env: process.env.NODE_ENV,
  ...coreCommonConfig,
  ...commonConfig,
  ...coreEnvironmentConfig,
  ...environmentConfig,
  ...userGuideConfig,
};
